import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcArrowBack32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m26 16c0-.562-.438-1-1-1h-15.594l6.314-6.28a.961.961 0 0 0 .28-.72c0-.562-.406-1-1-1-.25 0-.5.063-.719.282l-8 8a.962.962 0 0 0 -.281.718c0 .25.063.5.281.719l8 8a.963.963 0 0 0 .72.281c.593 0 1-.469 1-1 0-.25-.063-.5-.282-.719l-6.313-6.28h15.594c.563 0 1-.438 1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcArrowBack32;
